import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
    Box,
} from "@mui/material";
import DashboardLayout from "reusableComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "reusableComponents/Navbars/DashboardNavbar";
import {useSoftUIController} from "../../context";
import {
    fetchFilesByBatch,
    deliverFileById,
    updateFileStatus,
    getBatchFilesStatus,
    digitizeFileById,
    updateFileNotes,
    rerunDigitization,
    runQualityCheck,
    startBatch, stopBatch, startDeliveryBatch, stopDeliveryBatch, acceptBatch, uploadMissingFiles, startBatchQualityCheck, stopBatchQualityCheck
} from "../../axios-client";
import ConfirmationDialog from "../../reusableComponents/alerts/ConfirmationDialog";
import SelectOCRTypeConfirmationDialog from "../../reusableComponents/alerts/SelectOCRTypeConfirmationDialog";
import { io } from "socket.io-client";
import FileFiltersCard from "./FileFiltersCard";
import {formatDurationValue} from "../../utlis/generalUtils";
import {useTranslation} from "react-i18next";
import {SUPER_ADMIN} from "../../constants/constants";
import SnackbarNotification from "../../reusableComponents/Snackbar/SnackbarNotification";
import {buildFileRow} from "./buildFileRow";
import BatchFilesTableSection from "./BatchFilesTableSection";
import BatchOverviewCard from "./BatchOverviewCard";
function BatchFilesPage() {

    const location = useLocation();
    const id = new URLSearchParams(location.search).get("id");
    const [controller] = useSoftUIController();
    const { role} = controller;
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [count, setCount] = useState(0);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogSelectOCRTypeOpen, setDialogSelectOCRTypeOpen] = useState(false);
    const [dialogAction, setDialogAction] = useState(null);
    const [entityName, setEntityName] = useState(null);
    const [dialogFileId, setDialogFileId] = useState(null);
    const [selectedOCRType, setSelectedOCRType] = useState(null);
    const [selectedOCRTypeError, setSelectedOCRTypeError] = useState(false);
    

    const [socket, setSocket] = useState(null);
    const [nameFilter, setNameFilter] = useState("");
    const [notesFilter, setNotesFilter] = useState("");
    const [tablesFilter, setTablesFilter] = useState([0, 100]);
    const [statusFilter, setStatusFilter] = useState("all");
    const [qualityFilter, setQualityFilter] = useState("all");
    const [loadingQualityId, setLoadingQualityId] = useState(null);

    const [filesStatus, setFilesStatus] = useState({})
    const [batchName, setBatchName] = useState("")
    const [daemonStatus, setDaemonStatus] = useState("")
    const [deliveryDaemonStatus, setDeliveryDaemonStatus] = useState("")
    const [qualityCheckDaemonStatus, setQualityCheckDaemonStatus] = useState("")
    const [batchStatus, setBatchStatus] = useState("")
    const [autoRestart, setAutoRestart] = useState(false)
    const [pageCount, setPageCount] = useState(0)
    const [filesCount, setFilesCount] = useState(0)

    const [selectedRows, setSelectedRows] = useState([]);
    const [editingFileId, setEditingFileId] = useState(null);
    const [editedNotes, setEditedNotes] = useState("");
    const [hoveredRowId, setHoveredRowId] = useState(null);

    const [notification, setNotification] = useState({
        show: false,
        snackbarMessage: "",
        severity: "",
    });

    useEffect(() => {
        if (!socket) return;

        if (["pending", "in_progress", "partially_done", "done", "partially_delivered"].includes(batchStatus)) {
            const eventName = `batch_status_update-${id}`;
            socket.on(eventName, (data) => {
                setFilesStatus(data.batch_status)
                if (batchStatus !== data.status) {
                    setBatchStatus(data.status);
                }
            });
        }

        return () => {
            socket.off(`batch_status_update-${id}`);
        };
    }, [id, batchStatus, socket]);

    useEffect(() => {
        if (!socket || files.length === 0) return;

        files.forEach((file) => {
            if (["pending", "in_progress", "done", "partially_done", "partially_delivered"].includes(batchStatus) &&
                ["pending", "in_progress","completed", "partially_completed", "delivery_in_progress"].includes(file.status)) {
                const eventName = `file_status_update-${file.id}`;
                socket.on(eventName, (data) => {
                    setFiles((prev) =>
                        prev.map((f) =>
                            f.id === data.file_id ? {...f, status: data.file_status} : f
                        )
                    );
                })
            }
        });

        return () => {
            files.forEach((file) => socket.off(`file_status_update-${file.id}`));
        };
    }, [files, socket]);

    useEffect(() => {
        loadFiles(page, size);
    }, [page, size, nameFilter, statusFilter, notesFilter, tablesFilter, qualityFilter]);

    useEffect(() => {
        setPage(1);
    }, [nameFilter, statusFilter, notesFilter, qualityFilter]);

    useEffect(() => {
        const baseURL = window?.appConfig?.REACT_APP_SOCKET_SERVER || process.env.REACT_APP_SOCKET_SERVER;
        const s = io(baseURL, { path: "/socket.io" });
        setSocket(s);

        loadBatchFileStatus();

        return () => s.disconnect();
    }, []);

    const loadFiles = async (pageNum = 1, pageSize = 8) => {
        setLoading(true);
        try {
            const res = await fetchFilesByBatch(id, pageNum, pageSize,
                nameFilter !== "" ? nameFilter : undefined,
                statusFilter !== "all" ? statusFilter : undefined,
                notesFilter !== "" ? notesFilter : undefined,
                tablesFilter !== "" ? tablesFilter : undefined,
                qualityFilter !== "all" ? qualityFilter : undefined

            )
            setFiles(res.data.items || []);
            setCount(res.data.total || 0);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const loadBatchFileStatus = async () => {

        try {
            const res = await getBatchFilesStatus(id);
            if (res && res.data) {
                setFilesStatus(res.data.batch_status);
                setBatchName(res.data.batch_name)
                setDeliveryDaemonStatus(res.data.delivery_daemon_status)
                setQualityCheckDaemonStatus(res.data.quality_check_daemon_status)
                setDaemonStatus(res.data.daemon_status)
                setBatchStatus(res.data.status)
                setAutoRestart(res.data.auto_restart)
                setPageCount(res.data.page_count)
                setFilesCount(res.data.files_count)
            }
        } catch (err) {
            console.error(err);
        } finally {
        }
    }

    const startEditingNotes = (file) => {
    setEditingFileId(file.id);
    setEditedNotes(file.notes || "");
    };

    const cancelEditingNotes = () => {
        setEditingFileId(null);
        setEditedNotes("");
    };

    const saveNotes = async (fileId) => {
        try {
            await updateFileNotes(fileId, editedNotes);
            setNotification({
                show: true,
                snackbarMessage: "Notes updated successfully",
                severity: "success",
            });
            cancelEditingNotes();
            loadFiles(page, size);
        } catch (err) {
            console.error(err);
            setNotification({
                show: true,
                snackbarMessage: "Failed to update notes",
                severity: "error",
            });
        }
    };

    const handleSelectionChange = (newSelectedRows) => {
        setSelectedRows(newSelectedRows);
    };

    const handleFileStatusUpdate = async (fileIds, newStatus) => {
        if (!fileIds?.length || !newStatus) {
            setNotification({
                show: true,
                snackbarMessage: 'No files selected or status chosen',
                severity: 'warning',
            });
            return;
        }

        try {
            await updateFileStatus(fileIds, newStatus);
            setNotification({
                show: true,
                snackbarMessage: `${fileIds.length} file(s) status updated successfully`,
                severity: 'success',
            });
            setSelectedRows([]);
            loadFiles(page, size);
            loadBatchFileStatus()
        } catch (err) {
            console.error(err);
            setNotification({
                show: true,
                snackbarMessage: 'Failed to update file statuses',
                severity: 'error',
            });
        }
    };

    const handlePageChange = (newPage) => setPage(newPage);
    const handleRowsPerPageChange = (newSize) => {
        setSize(newSize);
        setPage(1);
    };

    const openConfirmation = (entityName, action, fileId) => {

        setDialogAction(action);
        setEntityName(entityName)
        if (entityName === "file") setDialogFileId(fileId);
        setDialogOpen(true);
    };

    const openSelectOCRTypeConfirmation = (entityName, action, fileId) => {

        setDialogAction(action);
        setEntityName(entityName)
        if (entityName === "file") setDialogFileId(fileId);
        setDialogSelectOCRTypeOpen(true);
    };

    const handleSelectedOcrTypeChange = (value) => {
        setSelectedOCRType(value)
    }

    const handleAction = async () => {
        if (entityName === "batch") {
            await handleBatchAction()
        } else {
            await handleFileAction()
        }
    }

    const handleConfirmAction = async () => {

         if (selectedOCRType == null || !['default', 'agentic', 'light'].includes(selectedOCRType)) {
            setSelectedOCRTypeError(true)
            setSelectedOCRType('')
            return;
        }

        if (entityName === "batch") {
            if (dialogAction === "start") {
                await startBatch(id, selectedOCRType);
            }        
        
        } else {
            if (dialogAction === "digitize") 
                await digitizeFileById(dialogFileId, selectedOCRType).catch((e) => {
                
                    setNotification({ show: true, snackbarMessage: 'An unexpected error occurred', severity: 'error' });
                });  
        }
        setSelectedOCRTypeError(false)
        setDialogSelectOCRTypeOpen(false)
        setSelectedOCRType('')
        if (entityName === "file") setDialogFileId(null);
        setEntityName(null)
    }

    const handleBatchAction = async () => {
        if (!dialogAction || !id) return;
        try {
            if (dialogAction === "stop") await stopBatch(id);
            else if (dialogAction === "startDelivery") await startDeliveryBatch(id);
            else if (dialogAction === "stopDelivery") await stopDeliveryBatch(id);
            else if (dialogAction === "startQualityCheck") await startBatchQualityCheck(id);
            else if (dialogAction === "stopQualityCheck") await stopBatchQualityCheck(id);
            else if (dialogAction === "accept") await acceptBatch(id);
            else if (dialogAction === "uploadMissingFiles") await uploadMissingFiles(id);
            if (socket) {
                const eventName = `batch_status_update-${id}`;
                socket.on(eventName, (data) => {
                    setBatchStatus(data.status)
                    setDaemonStatus(data.daemon_status)
                    setDeliveryDaemonStatus(data.delivery_daemon_status)
                    setQualityCheckDaemonStatus(data.quality_check_daemon_status)
                });
            }
        } catch (e) {
            setNotification({ show: true, snackbarMessage: 'An unexpected error occurred', severity: 'error' });
        } finally {
            clearTemporaryData()
        }
    };

    const handleFileAction = async () => {
        if (!dialogAction || !dialogFileId) return;

        try {
            if (dialogAction === "deliver") await deliverFileById(dialogFileId).catch((e) => {
                setNotification({ show: true, snackbarMessage: 'An unexpected error occurred', severity: 'error' });
            });

            if (dialogAction === "rerun") await rerunDigitization(dialogFileId).catch((e) => {
                setNotification({ show: true, snackbarMessage: 'An unexpected error occurred', severity: 'error' });
            });

            if (dialogAction === "startQualityCheck") {
                setLoadingQualityId(dialogFileId);
                setDialogOpen(false)

                await runQualityCheck(dialogFileId)
                    .catch(() => {
                        setNotification({
                            show: true,
                            snackbarMessage: 'An unexpected error occurred',
                            severity: 'error'
                        });
                    });
            }

            if (socket) {
                const eventName = `file_status_update-${dialogFileId}`;
                socket.on(eventName, (data) => {
                    setFiles(prev =>
                        prev.map(f =>
                            f.id === dialogFileId ? { ...f, status: data.file_status } : f
                        )
                    );
                });
            }
            loadFiles(page, size);

        } catch (err) {
            console.error(err);
        } finally {
            clearTemporaryData()
        }
    };

    const handleQualityFilterChange = (value) => {
        setQualityFilter(value);
    };

    const clearTemporaryData = () => {
        setDialogOpen(false);
        setDialogAction(null);
        if (entityName === "file") setDialogFileId(null);
        setEntityName(null)
        setLoadingQualityId(null);
    };

    const handleStatusChange = async (fileId, newStatus) => {
        handleFileStatusUpdate([fileId], newStatus);
    }

    const rows = files.map((file) =>
        buildFileRow({
            file,
            role,
            currentLang,
            editingFileId,
            hoveredRowId,
            editedNotes,
            setEditedNotes,
            setHoveredRowId,
            startEditingNotes,
            saveNotes,
            cancelEditingNotes,
            handleStatusChange,
            openConfirmation,
            openSelectOCRTypeConfirmation,
            formatDurationValue,
            loadingQualityId
        })
    );

    return (
        <DashboardLayout>
        <DashboardNavbar />
        <Box sx={{ p: 4 }}>

            {role === SUPER_ADMIN &&
                <BatchOverviewCard
                    id={id}
                    role={role}
                    batchStatus={batchStatus}
                    daemonStatus={daemonStatus}
                    deliveryDaemonStatus={deliveryDaemonStatus}
                    qualityCheckDaemonStatus={qualityCheckDaemonStatus}
                    autoRestart={autoRestart}
                    setAutoRestart={setAutoRestart}
                    batchName={batchName}
                    setNotification={setNotification}
                    openConfirmation={openConfirmation}
                    openSelectOCRTypeConfirmation={openSelectOCRTypeConfirmation}
                    fileStatus={filesStatus}
                    pageCount={pageCount}
                    filesCount={filesCount}
                />
            }

            <FileFiltersCard
                nameFilter={nameFilter}
                statusFilter={statusFilter}
                notesFilter={notesFilter}
                tablesFilter={tablesFilter}
                setNameFilter={setNameFilter}
                setNotesFilter={setNotesFilter}
                setStatusFilter={setStatusFilter}
                setPage={setPage}
                setTablesFilter={setTablesFilter}
                role={role}
                qualityFilter={qualityFilter}
                onQualityFilterChange={handleQualityFilterChange}
                setQualityFilter={setQualityFilter}
            />

            <BatchFilesTableSection
                loading={loading}
                files={files}
                rows={rows}
                selectedRows={selectedRows}
                handleRowsPerPageChange={handleRowsPerPageChange}
                handlePageChange={handlePageChange}
                handleSelectionChange={handleSelectionChange}
                handleFileStatusUpdate={handleFileStatusUpdate}
                page={page}
                size={size}
                count={count}
                role={role}
            />

            <ConfirmationDialog
                open={dialogOpen}
                title={"Confirm Action"}
                onClose={() => {
                    clearTemporaryData()
                }}
                onConfirm={handleAction}
                message={`Are you sure you want to ${dialogAction} this  ${entityName}?`}
            />

            
            <SelectOCRTypeConfirmationDialog
                open={dialogSelectOCRTypeOpen}
                title={"Confirm Action"}
                onClose={() => {
                    setDialogSelectOCRTypeOpen(false)
                    if (entityName === "file") setDialogFileId(null);
                    setEntityName(null)
                }}
                onConfirm={handleConfirmAction}
                ocrType={selectedOCRType}
                ocrTypeError={selectedOCRTypeError}
                handleOcrTypeChange={handleSelectedOcrTypeChange}
            />

            <SnackbarNotification
                notification={notification}
                setNotification={setNotification}
            />
        </Box>
        </DashboardLayout>
    );
}

BatchFilesPage.propTypes = {
};


export default BatchFilesPage;